import { render, staticRenderFns } from "./DownloadMenu.vue?vue&type=template&id=6a889690&scoped=true"
import script from "./DownloadMenu.vue?vue&type=script&lang=js"
export * from "./DownloadMenu.vue?vue&type=script&lang=js"
import style0 from "./DownloadMenu.vue?vue&type=style&index=0&id=6a889690&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a889690",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\_\\glatzb2c_2022\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a889690')) {
      api.createRecord('6a889690', component.options)
    } else {
      api.reload('6a889690', component.options)
    }
    module.hot.accept("./DownloadMenu.vue?vue&type=template&id=6a889690&scoped=true", function () {
      api.rerender('6a889690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/elements/downloadoverview/assets/vue/DownloadMenu.vue"
export default component.exports